import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Clock, LogOut } from "lucide-react";
import { LOGO_URL } from "@/lib/translations";

export default function Pending() {
  const { user, logout } = useAuth();
  const { t } = useI18n();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <Card className="w-full max-w-md p-8 text-center animate-fade-up" data-testid="pending-screen">
        <div className="mb-6 flex justify-center rounded-xl border bg-white p-5">
          <img src={LOGO_URL} alt="Horizonte Documenta" className="h-12 w-auto object-contain" />
        </div>
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-horizonte-orange/15 text-horizonte-orange">
          <Clock className="h-7 w-7 animate-pulse-ring" />
        </div>
        <h1 className="font-display text-2xl font-bold">{t("pendingTitle")}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{t("pendingDesc")}</p>
        <div className="mt-6 rounded-lg bg-secondary px-4 py-3 text-sm">
          <span className="text-muted-foreground">{t("signedInAs")}: </span>
          <span className="font-medium">{user?.email}</span>
        </div>
        <Button variant="outline" onClick={logout} data-testid="pending-logout-button" className="mt-6 w-full">
          <LogOut className="mr-2 h-4 w-4" /> {t("logout")}
        </Button>
      </Card>
    </div>
  );
}
